import config from '../../../config';

export const FETCH_CLIENTS_REQUEST = 'FETCH_CLIENTS_REQUEST';
export const FETCH_CLIENTS_SUCCESS = 'FETCH_CLIENTS_SUCCESS';
export const FETCH_CLIENTS_FAILURE = 'FETCH_CLIENTS_FAILURE';


export const fetchClientsRequest = () => {
  return{
    type: FETCH_CLIENTS_REQUEST
  }
}

export const fetchClientsSuccess = (clients) => {
  return {
    type: FETCH_CLIENTS_SUCCESS,
    clients: clients
  }
}
export const fetchClientsFailure = (error) => {
  return {
    type: FETCH_CLIENTS_FAILURE,
    error
  }
}

export const fetchClients = () => {
  return dispatch => {
    dispatch(fetchClientsRequest());

    return fetch(`${config.apiBase}/posts`)
      .then(response => response.json())
      .then(json => dispatch(fetchClientsSuccess(json)))
  }
}

export const FETCH_PAGES_REQUEST = 'FETCH_PAGES_REQUEST';
export const FETCH_PAGES_SUCCESS = 'FETCH_PAGES_SUCCESS';
export const FETCH_PAGES_FAILURE = 'FETCH_PAGES_FAILURE';


export const fetchPagesRequest = () => {
  return{
    type: FETCH_PAGES_REQUEST
  }
}

export const fetchPagesSuccess = (pages) => {
  return {
    type: FETCH_PAGES_SUCCESS,
    pages: pages
  }
}
export const fetchPagesFailure = (error) => {
  return {
    type: FETCH_PAGES_FAILURE,
    error
  }
}

export const fetchPages = () => {
  return dispatch => {
    dispatch(fetchPagesRequest());

    return fetch(`${config.apiBase}/pages`)
      .then(response => response.json())
      .then(json => dispatch(fetchPagesSuccess(json)))
  }
}
